import './utils/system.copyright'
// import { createApp, vaporInteropPlugin } from 'vue'
import ElementPlus from './provider-element'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VXEUI from './provider-vxetable/vxe-pc-ui-index'
import VXETable from './provider-vxetable'

import App from './App.vue'
import pinia from './store'
import router from './router'
/* https://docs.sentry.io/platforms/javascript/guides/vue/ 20250115 */
import * as Sentry from "@sentry/vue"
import useSettingsStore from './store/modules/settings'
// custom svg 20231017
// import svgIconCustom from './components/SvgIconCustom/index.vue'

// 自定义指令
import directive from '@/utils/directive'
// 加载 svg 图标
import 'virtual:svg-icons-register'

// 全局样式
// import '@/assets/styles/globals.scss'
import '@/assets/styles/custom-theme/index.scss'
// import StarfishEditor from "starfish-editor";
// import "starfish-editor/src/styles/index.scss";
// global filters
import * as filters from './filters'

// 加载 iconify 图标（element plus）
import { downloadAndInstall } from '@/iconify-ep'

const app = createApp(App)

// every page component unuse import { ArrowDown, ArrowUp } from '@element-plus/icons-vue', at this global import 20250114
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// register global utility filters
// Object.keys(filters).forEach(key => {
//   app.filter(key, filters[key])
// })
// app.use(filters)
app.config.globalProperties.$filters = filters

Sentry.init({
  app,
  dsn: "https://8a9931f132af417d943132a43f48a9e6@sentry.lecoosys.com/2",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
// app.use(vaporInteropPlugin)
app.use(ElementPlus)
app.use(VXEUI)
app.use(VXETable)
// app.use(StarfishEditor)
app.use(pinia)
app.use(router)
directive(app)
if (useSettingsStore().settings.app.iconifyOfflineUse) {
  downloadAndInstall()
}

app.mount('#app')
